import { FormControl, Validators } from '@angular/forms';

export class LaudoInputFotoAdicional {

    id: any;
    required: boolean = false;
    label = new FormControl('');
    image = new FormControl('', Validators.required);
    loading = false;
    
    constructor(e) {
        this.id = e.id;
        this.image.patchValue(e.value || '');
        this.label.patchValue(e.label || e.descricao || '');
        this.loading = e.loading || false;
    }
}